import { render, staticRenderFns } from "./VRequestStep3.vue?vue&type=template&id=48ace65a&"
import script from "./VRequestStep3.vue?vue&type=script&lang=js&"
export * from "./VRequestStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports